import React from 'react';
import * as constants from '../../constants';
// eslint-disable-next-line react/prop-types
const SupportEmail = ({ requestId })=>/*#__PURE__*/ React.createElement('a', {
        href: `mailto:${constants.CONTACT_EMAIL}${requestId ? `?body=RequestId : ${requestId}` : ''}`
    }, constants.CONTACT_EMAIL);
export default SupportEmail;
